import axios from "axios";
import store from "@/store";
import router from "@/router"; 

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.defaults.withCredentials = true;

axios.interceptors.request.use(
    (config) => {
        const token = store.state.auth.token;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Controle de concorrência do Refresh
let isRefreshing = false;
let subscribers = [];

// Função auxiliar para empilhar requisições enquanto o refresh acontece
function subscribeTokenRefresh(cb) {
    subscribers.push(cb);
}

// Função para executar todas as requisições pausadas após o refresh ter sucesso
function onRefreshed(token) {
    subscribers.map((cb) => cb(token));
    subscribers = [];
}

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const { config, response } = error;
        const originalRequest = config;

        if (response && response.status === 401) {
            
            if (originalRequest.url.includes('/refresh') || originalRequest.url.includes('/logout')) {
                isRefreshing = false;
                subscribers = [];
                store.commit("auth/reset");
                return Promise.reject(error);
            }

            if (!isRefreshing) {
                isRefreshing = true;

                try {
                    const res = await axios.post("/refresh");
                    const novoToken = res.data.access_token;

                    store.commit("auth/setToken", novoToken);
                    
                    isRefreshing = false;
                    onRefreshed(novoToken);

                    originalRequest.headers.Authorization = `Bearer ${novoToken}`;
                    return axios(originalRequest);

                } catch (refreshError) {
                    isRefreshing = false;
                    subscribers = [];
                    store.commit("auth/reset");
                    router.push("/v2/login");
                    return Promise.reject(refreshError);
                }
            }

            const retryOriginalRequest = new Promise((resolve) => {
                subscribeTokenRefresh((token) => {
                    originalRequest.headers.Authorization = `Bearer ${token}`;
                    resolve(axios(originalRequest));
                });
            });

            return retryOriginalRequest;
        }

        return Promise.reject(error);
    }
);

export default axios;
